export const tableSettings = {
  initialSortColumn: 'lotNumber',
  pageSelectTitle: 'Product Images',
  searchFields: [
    { label: 'Lot Number', param: 'LotNumber' },
    { label: 'Stock Number', param: 'StockNumber' },
    { inputWidth: '400px', label: 'Product Name', param: 'ProductName' },
  ],
  standardStoreParams: [
    'pageNumber',
    'pageSize',
    'searchText',
    'sortColumn',
    'sortDirection',
    'mediaGalleryState',
  ],
  getMethods: (lane, auction) => {
    if (lane.id)
      return {
        args: ['laneID', ...tableSettings.standardStoreParams],
        dataToMerge: { laneID: lane.id },
        fn: lane.fn,
        name: 'lane',
      };

    if (auction.id)
      return {
        args: ['auctionID', ...tableSettings.standardStoreParams],
        dataToMerge: { auctionID: auction.id },
        fn: auction.fn,
        name: 'auction',
      };

    return null;
  },
};

const headerSchema = [
  { index: 8, sort: false, text: 'Action', value: 'productMediaGalleryID' },
  { index: 1, sort: false, text: 'Product Image', value: 'url' },
  { index: 2, sort: true, text: 'Product Name', value: 'product' },
  {
    index: 3,
    initialSort: true,
    sort: true,
    text: 'Lot Number',
    value: 'lotNumber',
  },
  { index: 4, sort: true, text: 'Stock Number', value: 'stockNumber' },

  { index: 5, sort: true, text: 'Sequence', value: 'sequence' },
  {
    index: 6,
    sort: true,
    text: 'Prod. Url Processed',
    value: 'dateProcessed',
  },
  { index: 7, sort: true, text: 'Lane Name', value: 'lane' },
];

const bodySchema = [
  {
    content: {
      type: 'tableButtons',
      value: [
        {
          args: ['productMediaGalleryID'],
          basic: false,
          fn: 'productImagesStateObject',
          icon: 'refresh',
          key: '[productMediaGalleryID]',
          primary: false,
          style: [
            {
              expr: 'x == 1',
              scope: {
                x: 'value',
              },
              style: {
                backgroundColor: '#2185d0',
                color: 'white',
              },
            },
          ],

          text: 'Reload',
          url: 'fn',
          value: 'hasError',
        },
      ],
    },
    debug: false,
    index: 8,
    value: 'productMediaGalleryID',
  },
  {
    content: {
      type: 'image',
      value: { alt: ['Lot #', '[lotNumber]', ': ', '[product]'] },
    },
    index: 1,
    value: 'url',
  },
  { content: { type: 'text', value: 'value' }, index: 2, value: 'product' },
  { content: { type: 'text', value: 'value' }, index: 3, value: 'lotNumber' },
  {
    content: { type: 'text', value: 'value' },
    index: 4,
    value: 'stockNumber',
  },
  {
    content: { type: 'text', value: 'value' },
    index: 5,
    value: 'sequence',
  },
  {
    content: { type: 'datetime', value: 'value' },
    format: 'MM/DD/YYYY h:mm A',
    index: 6,
    value: 'dateProcessed',
  },
  { content: { type: 'text', value: 'value' }, index: 7, value: 'lane' },
];

export const schema = {
  bodySchema,
  debugging: false,
  headerSchema,
  tableSettings,
};
